import React from "react";

const Height = {
	1: "h-1",
	2: "h-2",
};

const Width = {
	1: "w-1",
	2: "w-2",
};

const Color = {
	"text-primary": "bg-text-primary",
};

type DotProps = {
	size: keyof typeof Height;
	color: keyof typeof Color;
};

const Dot = ({ size, color }: DotProps) => (
	<span className={`${Height[size]} ${Width[size]} rounded-full ${Color[color]}`} />
);

type Props = {
	size: keyof typeof Height;
	color: keyof typeof Color;
	children: Iterable<React.ReactNode>;
};

const DotDivider = ({ size, color, children }: Props) => (
	<div className="flex list-inside list-disc flex-wrap items-center gap-2">
		{React.Children.map(children, (child, i) => {
			if (React.Children.toArray(children).length - 1 === i) {
				return child;
			}
			return (
				<>
					{child}
					<Dot size={size} color={color} />
				</>
			);
		})}
	</div>
);

export default DotDivider;
